import script from "./IpdSalesCollectionReport.vue?vue&type=script&setup=true&lang=js"
export * from "./IpdSalesCollectionReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__